/**
 * Webhook Service for external API notifications
 */

import api from './apiService';

const WEBHOOK_URL = 'https://spuvkgmlhov6uurg3o7qeqxczq0lxeqy.lambda-url.us-east-1.on.aws/';
const CHAT_ID = '-4666628004';

export class WebhookService {
  /**
   * Send notification to webhook URL directly
   * Note: May fail due to CORS restrictions, but won't break main functionality
   * @param {string} message - Message to send
   * @returns {Promise<void>}
   */
  static async sendNotification(message) {
    try {
      const response = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chat_id: CHAT_ID,
          message: message
        })
      });

      if (response.ok) {
        console.log('Webhook notification sent successfully');
      } else {
        // Log more details about the error
        const errorText = await response.text().catch(() => 'Unable to read error response');
        console.warn(`Webhook failed with status ${response.status}:`, errorText);
      }
    } catch (error) {
      // Expected to fail due to CORS restrictions in browser
      // This is normal behavior and won't affect main functionality
      console.warn('Webhook notification failed (likely due to CORS):', error.message);
    }
  }

  /**
   * Send image upload notification
   * @param {Object} influencer - Influencer object
   * @param {number} imageCount - Number of images being uploaded
   */
  static async sendImageUploadNotification(influencer, imageCount) {
    if (!influencer) return;

    const message = `🖼️ IMAGE UPLOAD STARTED
Influencer ID: ${influencer.id}
Influencer Name: ${influencer.models_name || influencer.name}
Login: ${influencer.models_login || influencer.login}
Images Count: ${imageCount}
Timestamp: ${new Date().toISOString()}`;

    await this.sendNotification(message);
  }

  /**
   * Send autotrain notification
   * @param {Object} influencer - Influencer object
   * @param {Object} autotrainerSettings - Autotrainer settings
   */
  static async sendAutotrainNotification(influencer, autotrainerSettings) {
    if (!influencer || !autotrainerSettings) return;

    const message = `🤖 AUTOTRAIN STARTED
Influencer ID: ${influencer.id}
Influencer Name: ${influencer.models_name || influencer.name}
Login: ${influencer.models_login || influencer.login}

Autotrainer Settings:
- Name: ${autotrainerSettings.name}
- Trigger: ${autotrainerSettings.trigger}
- Validation Prompt: ${autotrainerSettings.validation_prompt}
- Checkpoint: ${autotrainerSettings.checkpoint}
- Steps: ${autotrainerSettings.steps}
- Rank: ${autotrainerSettings.rank}
- Validation Steps: ${autotrainerSettings.validation_steps}
- Resolution: ${autotrainerSettings.resolution}
- Project: ${autotrainerSettings.project}
- LoRA Type: ${autotrainerSettings.lora_type}
- Learning Rate: ${autotrainerSettings.learning_rate}

Timestamp: ${new Date().toISOString()}`;

    await this.sendNotification(message);
  }
}

export default WebhookService;